import React, { Component, Fragment } from "react";
import { ALERT_MESSAGES, APP_BOOLEANS, APPLICATION_MODES, STAGES_GRID, TOUCHPOINTS_GRID } from "../../../../../constants/appConstants";
import { TatvamButton, TatvamGrid, TatvamModal, TatvamCol } from "../../../../functionalComponents";
import { trimCapitalize } from "../../../../../utils/stringUtil";
import IndustryTouchpointsImport from "../../../industryTouchpointsImport";
import { withRouter } from "react-router-dom";
import AlertBox from "../../../alertBox";
import IndustryTouchpointsForm from "../../../industryTouchpointForm";

class IndustryTouchpoints extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            colDef: [
                {
                    headerName: TOUCHPOINTS_GRID.SEQ_NO,
                    field: "sequence_no",
                    filterParams: {clearButton: true},
                    width: 225
                },
                {
                headerName: TOUCHPOINTS_GRID.STAGE_NAME,
                field: "stages",
                filterParams: {clearButton: true},
                width: 225
                },
                {
                    headerName: TOUCHPOINTS_GRID.TOUCHPOINT_NAME,
                    field: "touchpoints",
                    filterParams: {clearButton: true},
                    width: 225
                },
                {
                    headerName: TOUCHPOINTS_GRID.STATUS,
                    field: "status",
                    filterParams: {clearButton: true},
                    width: 227
                },
            ],
            isModalOpen: false,
            loader: true,
            showImportModal: false
        }
    }

    _handleDeleteConfirmation = (data) => {
        this.setState({
            id: data.id,
            idTouchpoint: data.id,
            isConfirmBox: true,
            isAlertBoxOpen: false,
            isDeleteAlertBoxOpen: true,
            isSuccess: false,
            alert_information: ALERT_MESSAGES.DELETE_CONFIRMATION
        });
    };

    _deleteRow = (data) => {
        if (data === "ok") {
            let touchpoint_id = this.state.id;
            let id = this.state.id;
            let touchpointDeleteData = {
                touchpoint_id,
                id
            };
            this.props.actions.deleteIndustryTouchpoint(touchpointDeleteData).then((response) => {
                this.setState({
                    loader: false
                });
                if (response.status === 200) {

                    this.setState({
                        shouldCloseModal: true,
                        isAlertBoxOpen: true,
                        isSuccess: true,
                        alert_information: response.data.message
                    });
                } else {
                    this.setState({
                        shouldCloseModal: false,
                        isAlertBoxOpen: true,
                        isSuccess: false,
                        alert_information: response.data ? response.data.message : response.message
                    });

                }
            });
        }
        this.setState({
            isConfirmBox: false,
            isAlertBoxOpen: false,
            isSuccess: false,
            isDeleteAlertBoxOpen: false
        });
    };

    _discard = (data) => {
        this.setState({
            isConfirmBox: false,
            isAlertBoxOpen: false,
            isSuccess: false
        });
    };

    _openViewModal = (data) => {
        this.setState({
           touchpointData: data[0],
            modalTitle: "",
            applicationMode: APPLICATION_MODES.VIEW,
            isModalOpen: true,
            loader: true
        });
    };

    componentDidMount() {
        let IndustryTouchpointsGridData = [];
        if (this.props.history.location.state.industryData.name) {
            this.setState({
                loader: true
            });

            this.props.actions.getIndustryTouchpoints(this.props.history.location.state.industryData.name).then(() => {

                this.setState({
                    loader: false
                });

            });
        }
        
        if (this.props.industryTouchpointsList.industryTouchpoints.touchpoints) {
            this.props.industryTouchpointsList.industryTouchpoints.touchpoints.map((data) => {
                if (data.status) {
                    let status = trimCapitalize(data.status);
                    if (status === APPLICATION_MODES.ACTIVE || status === APPLICATION_MODES.INACTIVE) {
                        IndustryTouchpointsGridData.push(data);
                    }
                }
            });
        }

        this.setState({
            IndustryTouchpointsGridData,
        }, () => {

            this.setActiveCount();
        });

    }

    setActiveCount = () => {
        const gridData = this.state.IndustryTouchpointsGridData;
        const noOfActive = gridData.filter(eachItem => eachItem.status === 'Active');
        this.props.statusCount(noOfActive.length,gridData.length);
    };

    componentWillReceiveProps(props) {
        let IndustryTouchpointsGridData = [];
        if (props.industryTouchpointsList.industryTouchpoints.touchpoints) {
            props.industryTouchpointsList.industryTouchpoints.touchpoints.map((data) => {
                if (data.status) {
                    let status = trimCapitalize(data.status);
                    if (status === APPLICATION_MODES.ACTIVE || status === APPLICATION_MODES.INACTIVE) {
                        IndustryTouchpointsGridData.push(data);
                    }

                }
            });
        }
        this.setState({
            IndustryTouchpointsGridData,
        }, () => {

            this.setActiveCount();
        });
    }

    _importStages = () => {
        this.setState({
            modalTitle: "",
            showImportModal: true
        });
    }
    _openCreateModal = () => {
        this.setState({
            stageData: [],
            modalTitle: TOUCHPOINTS_GRID.ADD_TITLE_INDUSTRY_TOUCHPOINT,
            applicationMode: APPLICATION_MODES.CREATE,
            isModalOpen: true,
            industryName:this.props.industryName
        });
    };


    closeModal = () => {
        this.setState({
            isModalOpen: false
        });
    };

    closeImportModal = () => {
        this.setState({
            showImportModal: false
        });
    };

    render() {
        return (
            <Fragment>
                <TatvamButton className="mt-1 ml-2 mr-2 right btn_primary"
                    onClick={this._openCreateModal} title="Add Xpath">
                    {'Add'}
                </TatvamButton>

                 <TatvamButton className="mt-1 ml-2 right ad-vis-btn btn_primary mr-1"
                        onClick={this._importStages}
                        title="Import Industry Touchpoint">
                        <i className="large material-icons">  import_contacts  </i>
                </TatvamButton>


                        {
                            this.state.IndustryTouchpointsGridData && this.state.IndustryTouchpointsGridData.length > 0 ? (
                                <TatvamCol s={12} className="grid-data-area">
                                    <TatvamGrid
                                        gridData={this.state.IndustryTouchpointsGridData}
                                        colData={this.state.colDef}
                                        rowSelection="multiple"
                                        onRowSelect={this._openViewModal}
                                        enableDeleteColumn={true}
                                        onRowDelete={this._handleDeleteConfirmation}
                                    />
                                </TatvamCol>
                            ) : this.state.loader ? (
                                <TatvamCol s={12} className="grid-empty-area">
                                    <h5>Loading...</h5>
                                </TatvamCol>
                            ) : (
                                <TatvamCol s={12} className="grid-empty-area">
                                    <h5>No Touchpoints available</h5>
                                </TatvamCol>
                            )
                        }

                {this.state.isModalOpen && (
                    <TatvamModal
                        open={this.state.isModalOpen}
                        header={this.state.modalTitle}
                        className="hideFooter"
                        options={{dismissible: false}}
                        fixedFooter={false}
                        children={(
                            <IndustryTouchpointsForm
                                applicationMode={this.state.applicationMode}
                                industryName={this.props.history.location.state.industryData.name}
                                closeModal={this.closeModal}
                                touchpointData={this.state.touchpointData}
                                nonEditable={this.state.nonEditable}
                            />
                        )}
                    />
                )
                }


                {this.state.isAlertBoxOpen && (
                    <AlertBox
                        open={this.state.isAlertBoxOpen}
                        isSuccess={this.state.isSuccess}
                        closeAlertBox={this._discard}
                        isConfirmBox={this.state.isConfirmBox}
                        alert_information={this.state.alert_information}
                    />
                )}
                {this.state.isDeleteAlertBoxOpen && (
                    <AlertBox
                        open={this.state.isDeleteAlertBoxOpen}
                        isSuccess={this.state.isSuccess}
                        closeAlertBox={this._deleteRow}
                        isConfirmBox={this.state.isConfirmBox}
                        alert_information={this.state.alert_information}
                    />
                )}

                    
                    {this.state.showImportModal && (
                    <TatvamModal
                        open={this.state.showImportModal}
                        header={this.state.modalTitle}
                        className="hideFooter"
                        options={{dismissible: false}}
                        fixedFooter={false}
                        children={(
                            <IndustryTouchpointsImport
                                closeModal={this.closeImportModal}
                                industryName={this.props.industryName}
                            />
                        )}
                    />
                )
                }
                </Fragment>
        )
    }
}

export default withRouter(IndustryTouchpoints);